// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View_wrapper__hImW4","header":"View_header__NOezA","footer":"View_footer__3fTVQ","spin":"View_spin__3jCzP"};